import React from 'react';
import { FireLitSite } from './components/FireLitSite';
export function App() {
  return <FireLitSite data-id="element-0" data-mp="35ckb29dc16k1" />;
}